// extracted by mini-css-extract-plugin
export default {"resultButton":"ToggleButtonComponent_resultButton__OCQzT"};